import React from 'react';
import {
  Container, Row, Col, Tab, Nav,
} from 'react-bootstrap';
import TrackVisibility from 'react-on-screen';
import { useTranslation } from 'react-i18next';
import { CertificatonCard } from './CertificatonCard';
// import projImg1 from '../assets/img/Certificate CS50.jpg';
import projImg2 from '../assets/img/Full Stack web.jpg';
import projImg3 from '../assets/img/sql.jpg';
// import projImg4 from '../assets/img/mongodb.jpg';
import projImg5 from '../assets/img/certificado1.png';
import projImg6 from '../assets/img/certificado5.png';
import projImg7 from '../assets/img/certificado2.png';
import projImg8 from '../assets/img/certificado3.png';
import projImg9 from '../assets/img/certificado4.png';
import 'animate.css';

export const Certifications = () => {
  const [t] = useTranslation('global');
  const projects = [
    {
      title: 'Microverse',
      description: t('certindividual.title2'),
      date: 'Sep. 2022 - Feb. 2024',
      imgUrl: projImg2,
      link1: 'https://drive.google.com/file/d/1t6e5I1XegSs-B68hWKN_NGqn87Y-SruM/view?usp=sharing',
      seeCertificate: t('certindividual.seeCertificate'),
    },
    {
      title: 'Coderhouse',
      imgUrl: projImg3,
      description: t('certindividual.title3'),
      date: 'Jan. 2022 - Dic. 2023',
      link1: 'https://drive.google.com/file/d/1uCS5Otuwu9OFQKN5JIQPI-xOc5UKEv-E/view?usp=sharing',
      seeCertificate: t('certindividual.seeCertificate'),
    },
    {
      title: 'FreeCode Camp',
      description: t('certindividual.title5'),
      imgUrl: projImg5,
      date: 'Apr. 2022 - Jun. 2023',
      link1: 'https://www.freecodecamp.org/certification/MaximoOrtelli/front-end-development-libraries',
      seeCertificate: t('certindividual.seeCertificate'),
    },
    {
      title: 'Microverse:',
      description: t('certindividual.title6'),
      imgUrl: projImg6,
      date: 'Sep. 2022 - Oct. 2023',
      link1: 'https://www.credential.net/ea5a2774-a137-4835-81dc-572029724435',
      seeCertificate: t('certindividual.seeCertificate'),
    },
    {
      title: 'FreeCode Camp',
      description: t('certindividual.title7'),
      imgUrl: projImg7,
      date: 'Jul. 2022 - Jan. 2023',
      link1: 'https://www.freecodecamp.org/certification/MaximoOrtelli/javascript-algorithms-and-data-structures',
      seeCertificate: t('certindividual.seeCertificate'),
    },
    {
      title: 'Microverse:',
      description: t('certindividual.title8'),
      imgUrl: projImg8,
      date: 'Sep. 2022 - Sep. 2023',
      link1: 'https://www.credential.net/7cc3fa58-37b3-409b-bce8-41b05b5e2de6',
      seeCertificate: t('certindividual.seeCertificate'),
    },
    {
      title: 'Microverse:',
      description: t('certindividual.title9'),
      imgUrl: projImg9,
      date: 'Sep. 2022 - Nov. 2023',
      link1: 'https://www.credential.net/1eec1ff3-e446-490b-9c09-58857e6fbbea',
      seeCertificate: t('certindividual.seeCertificate'),
    },

  ];

  return (
    <section className="project" id="certifications">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? 'animate__animated animate__fadeIn' : ''}>
                  <h2>{t('certifications.title')}</h2>
                  <div className='certdesc'>
                    <p className="text-white other">{t('certifications.description')}</p>
                  </div>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first" className="aca">{t('certifications.title')}</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? 'animate__animated animate__slideInUp' : ''}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => (
                            <CertificatonCard
                              key={index}
                              {...project}
                            />
                          ))}
                        </Row>
                      </Tab.Pane>
                      {/* Agrega más pestañas según sea necesario */}
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
